export default "__VITE_ASSET__EyLaTBKV__"